import { render, staticRenderFns } from "./InstructorViewCourse.vue?vue&type=template&id=046c3148&scoped=true"
import script from "./InstructorViewCourse.vue?vue&type=script&lang=js"
export * from "./InstructorViewCourse.vue?vue&type=script&lang=js"
import style0 from "./InstructorViewCourse.vue?vue&type=style&index=0&id=046c3148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c3148",
  null
  
)

export default component.exports